import {useMemo} from 'react';
import type {ManifestationStatus} from 'api/types';
import {useLocalization} from 'localization';

export const useManifestationStatusLabel = (
  status: ManifestationStatus,
  mode?: 'default' | 'mini',
): string => {
  const {tLoose} = useLocalization();
  return useMemo(() => {
    return tLoose(
      `entity.manifestation.status.${mode === 'mini' ? 'short' : 'full'}.${status}`,
    );
  }, [mode, status, tLoose]);
};
